import { forwardRef, type InputHTMLAttributes, type JSX } from 'react';
import clsx from 'clsx';
import { FilterField } from './FilterField';

type FilterInputSize = 'sm' | 'md';

interface FilterInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label: string;
  id: string;
  containerClassName?: string;
  size?: FilterInputSize;
}

/**
 * FilterInput standardizes text inputs used within dashboard filter bars.
 */
export const FilterInput = forwardRef<HTMLInputElement, FilterInputProps>(function FilterInput(
  { label, id, containerClassName, className, size = 'md', ...rest },
  ref,
): JSX.Element {
  const sizeClasses: Record<FilterInputSize, string> = {
    md: 'px-4 py-3 text-base md:text-sm',
    sm: 'px-4 py-2.5 text-base md:py-2 md:text-xs',
  };

  return (
    <FilterField label={label} htmlFor={id} className={containerClassName}>
      <input
        id={id}
        ref={ref}
        className={clsx(
          'w-full rounded-xl border border-surface-subtle bg-white shadow-sm transition focus:border-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-primary/30',
          sizeClasses[size],
          className,
        )}
        {...rest}
      />
    </FilterField>
  );
});

FilterInput.displayName = 'FilterInput';
